import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';

@Component({
  selector: 'app-url',
  template: `
  <div [formGroup]="group" *ngIf="field.style.visibility" class="urlField">
  <div class="hazard-description">
    <a href="{{field.data.url}}" target="_blank" [ngClass]="{'pointer-events' : !field.style.editability}">{{field.data.url}}</a>
  </div>
</div>
  `,
  styles: [`.hazard-description{margin: 10px 0}`]
})
export class UrlComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/url/url.component.ts